import { Fragment, useEffect } from 'react';
import { Tooltip } from 'antd';

import { useAuth, usePost } from 'hooks';
import { tradeshowCalendarDownload } from 'services/api';
import Export from 'components/Export';
import { downloadType } from 'components/Export/Summary/constants';
import { DisabledButtonWrapper } from 'components/common/styled';
import { handleFailedExportNotification } from 'components/Search/Results/Actions/notifications';
import { handleExportNotification } from 'reducers/notifications';
import { UpgradeLicense } from 'utils/constants';

import {
  buildTradeshowCalendarExportBody,
  isTradeshowCalendarExportTooLarge,
  tooLargeTooltip,
} from '../helpers/export';

const ExportTradeshowCalendarButton = ({ filteredData = [], filters = {} }) => {
  const { user } = useAuth();
  const [
    { res: tradeshowCalendarDownloadTriggered, error, loading },
    postTradeshowCalendarDownload,
  ] = usePost({
    url: tradeshowCalendarDownload,
  });

  useEffect(() => {
    if (tradeshowCalendarDownloadTriggered) {
      handleExportNotification();
    }
  }, [tradeshowCalendarDownloadTriggered]);

  useEffect(() => {
    if (error) {
      handleFailedExportNotification(error.status);
    }
  }, [error]);

  if (user.disableExport || user.isRateLimited) {
    return null;
  }

  const tooLarge = isTradeshowCalendarExportTooLarge(filteredData.length);
  const getExportBody = () =>
    buildTradeshowCalendarExportBody({ filteredData, filters });

  const handleDownload = params => {
    const body = getExportBody();
    postTradeshowCalendarDownload({
      body: { ...body, ...params },
    });
  };

  const ButtonWrapper =
    user.isPartnerAccount || tooLarge ? DisabledButtonWrapper : Fragment;

  return (
    <Tooltip
      title={
        user.isPartnerAccount ? (
          <UpgradeLicense />
        ) : tooLarge ? (
          tooLargeTooltip
        ) : (
          ''
        )
      }
    >
      <ButtonWrapper>
        <Export
          downloadType={downloadType.tradeshowCalendar}
          getQueryBody={getExportBody}
          onExport={handleDownload}
          disabled={
            loading ||
            tooLarge ||
            user.isPartnerAccount ||
            filteredData.length === 0
          }
          canUseCredits={false}
          style={{ width: '100%', height: '32px' }}
        >
          Export Tradeshow Calendar
        </Export>
      </ButtonWrapper>
    </Tooltip>
  );
};

export default ExportTradeshowCalendarButton;
